export default __webpack_public_path__ + "static/media/left.eed1cc0b.svg";